import type { FormControl } from '@angular/forms';

import { isEmpty } from '@core/utils-legacy';

export function emailLocalPartValidator(
  control: FormControl<string | null>,
): { email: boolean } | null {
  const EMAIL_LOCAL_PART_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))$/;

  return isEmpty(control.value) || EMAIL_LOCAL_PART_PATTERN.test(control.value)
    ? null
    : { email: true };
}
